<template>
  <div class="home">
    <h1>"Welcome to Toolindo"</h1>
  </div>
</template>

<script>
export default {
  name: 'home',
};
</script>
